import {
    ENGINEERS_REQUEST,
    ENGINEERS_SUCCESS,
    ENGINEERS_FAILURE,
    ENGINEERS_SYNC_REQUEST,
    ENGINEERS_SYNC_SUCCESS,
    ENGINEERS_SYNC_FAILURE,
    UPDATE_ENGINEER_REQUEST,
    UPDATE_ENGINEER_SUCCESS,
    UPDATE_ENGINEER_FAILURE,
    ENGINEER_DOCUMENT_UPLOAD_REQUEST,
    ENGINEER_DOCUMENT_UPLOAD_SUCCESS,
    ENGINEER_DOCUMENT_UPLOAD_FAILURE,
    ENGINEER_DOCUMENT_DELETE_REQUEST,
    ENGINEER_DOCUMENT_DELETE_SUCCESS,
    ENGINEER_DOCUMENT_DELETE_FAILURE,
} from '../actions';

export const ENGINEERS_INITIAL_STATE = {
    isSyncing: false,
    isFetching: false,
    data: [],
    error: null,
    syncError: null,
};

import engineer from './engineer';
const engineerReducer = (state, action) => {
    let {data} = state;
    const {engineer: id} = action;
    const eng = data.find(b => b.id === id);
    const reduced = engineer(eng, action);
    data.splice(data.indexOf(eng), 1, reduced);
    data = [...data];

    return {...state, data};
};

const engineersReducers = {
    [ENGINEERS_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [ENGINEERS_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [ENGINEERS_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [ENGINEERS_SYNC_REQUEST]: (state) => {
        return {...state, isSyncing: true, syncError: null};
    },
    [ENGINEERS_SYNC_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isSyncing: false, syncError: null};
    },
    [ENGINEERS_SYNC_FAILURE]: (state, {error}) => {
        return {...state, isSyncing: false, syncError: error};
    },
    [UPDATE_ENGINEER_REQUEST]: engineerReducer,
    [UPDATE_ENGINEER_SUCCESS]: engineerReducer,
    [UPDATE_ENGINEER_FAILURE]: engineerReducer,
    [ENGINEER_DOCUMENT_UPLOAD_REQUEST]: engineerReducer,
    [ENGINEER_DOCUMENT_UPLOAD_SUCCESS]: engineerReducer,
    [ENGINEER_DOCUMENT_UPLOAD_FAILURE]: engineerReducer,
    [ENGINEER_DOCUMENT_DELETE_REQUEST]: engineerReducer,
    [ENGINEER_DOCUMENT_DELETE_SUCCESS]: engineerReducer,
    [ENGINEER_DOCUMENT_DELETE_FAILURE]: engineerReducer,
};

export default function engineers(state = ENGINEERS_INITIAL_STATE, action) {
    let reducer = engineersReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/engineers.js